import { Component } from 'src/utils';
import subHeaderImg from './../../../images/banner-image.jpg';
import subHeaderImgDesktop from './../../../images/banner-image-desktop.jpg';
import confirmImg from './../../../images/tick-sent.png';
import logo from './../../../images/logo-s.png';
import logoOutline from './../../../images/logo.png';
import info from './../../../images/question.png';
import template from './signup.html';
@Component({
  controllerAs: 'signup',
  template
})

export default class SignupContainer {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    '$stateParams',
    'authActions',
    'spinnerService',
    'authService',
    '$analytics',
    '$location',
    '$sce',
    '$uibModal',
    'APP',
    '$rootScope',
    'orderService'
  ];

  constructor($scope, $ngRedux, $state, $stateParams,
    authActions, $spinner, authService, $analytics, $location, $sce, $uibModal, APP, $rootScope, $order) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    if ($stateParams.email) {
      this.email = $stateParams.email;
      $location.search('email', null);

    }
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.APP = APP;
    this.authActions = authActions;
    this.authService = authService;
    this.subHeaderImg = subHeaderImg;
    this.subHeaderImgDesktop = subHeaderImgDesktop;
    this.confirmImg = confirmImg;
    this.logo = logo;
    this.logoOutline = logoOutline;
    this.$order = $order;
    if ($stateParams.storeName && $stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      this.storeName = $stateParams.storeName;
    } else {
      this.storeName = this.authService.getGuestStoreDetail().storeName;
    }
    this.$analytics = $analytics;
    this.info = info;
    this.$spinner = $spinner;
    this.$sce = $sce;
    this.$uibModal = $uibModal;
    this.$rootScope = $rootScope;
    this.textline1 = "Please allow up to 5 minutes before clicking the 'Resend Email' button.";
    this.textline2 = "This email may end up in your junk or spam folder.  Please whitelist donotreply@wbu.com to ensure delivery.";
    this.textline3 = "If you click 'Resend Email' please choose on the most recently sent email to confirm your email address.";
    var eventAction = 'Registration';
    this.isRegistering = false;
    
    
    this.emailUpdated = sessionStorage.getItem('isEmailUpdated');
    if(this.emailUpdated && !this.$rootScope.inOrderPage){
      this.requestSent = true;
      this.success = null;
      this.error = null;
      this.activationId = sessionStorage.getItem('activationId');
      this.email = sessionStorage.getItem('userEmail');
      sessionStorage.removeItem('activationId');
      sessionStorage.removeItem('isEmailUpdated');
      sessionStorage.removeItem('userProfile');
    }
   // console.log(typeof $analytics);
    $analytics.eventTrack(eventAction,
      {
        category: 'Registration',
        label: this.storeName
      }
    );
    $spinner.show('appSpinner');
    authService.getStoreDetail(this.storeName)
      .then(() => $spinner.hide('appSpinner'));
      authService.getCountries().then(() => {
      });

      const guestUserDetails = sessionStorage.getItem('userDetailsFromGuestSuccessfulOrder') ? JSON.parse(sessionStorage.getItem('userDetailsFromGuestSuccessfulOrder')) : null;
      console.log("guestUserDetails==", guestUserDetails);
      if(guestUserDetails && guestUserDetails.email!=null && guestUserDetails.inOrderPage) {
        this.requestSent = false;
        this.doGuestOptIn(guestUserDetails.orderId);
        this.isOrderPage = guestUserDetails.inOrderPage;
        this.email = guestUserDetails.email;
        this.firstName = guestUserDetails.firstName;
        this.lastName = guestUserDetails.lastName;
        sessionStorage.removeItem('userDetailsFromGuestSuccessfulOrder');
      }

      // this.isOrderPage = this.$rootScope.inOrderPage;
      // if (this.isOrderPage) {
      //   this.email = this.$rootScope.guestCheckoutEmail;
      // }
    $scope.$on('$destroy', () => {
      this.$rootScope.inOrderPage = false;
      this.$rootScope.guestCheckoutEmail = null;
    });
  }

  mapState(state) {
    return {
      store: state.auth.storeDetail,
      billingCountries: state.auth.countries
    };
  }

  submit(form) {
    if (form.$invalid) {
      return;
    }
    form.error = {};
    var ctrl = this;
    if (this.confirmPassword === this.password) {
      ctrl.signupForm = form;
      ctrl.$spinner.show('appSpinner');
      ctrl.isRegistering = true;
      this.authService.verifyCustomerEmail({
        email: this.email,
        agreement: this.agreement,
        phoneNumber: this.phoneNumber,
        store: {
          storeURLName: this.storeName
        }
      })
      .then(
        success => {
          ctrl.sendEmailStore = false;
          ctrl.$spinner.hide('appSpinner');
          ctrl.registration(ctrl);
        },
        error => {
          ctrl.$spinner.hide('appSpinner');
          ctrl.isRegistering = false;
          if (error.data.errorCode === 607) {
            this.noEmailError = true;
            return;
          } else if (error.data.errorCode === 705) {
            if (ctrl.isOrderPage) {
              ctrl.registration(ctrl);
            } else {
              ctrl.registrationWelcome(ctrl);            
            }
          } else {
            this.noEmailError = false;            
            if (error.data.errorCode === 615 || error.data.errorCode === 605) {
              ctrl.signupForm.error = error.data;
            }  else  if (error.data.errorCode === 667) {
              ctrl.signupForm.error = error.data;
             } else {
              ctrl.signupForm.error = { message: 'Registration Failed Please try again!' };
            }
          }
        });
    }
    else {
      form.error.message = 'Password mismatch';
    }
  }

  registration(ctrl) { 
    ctrl.$spinner.show('appSpinner');
    let isRegisteringFromGuest = ctrl.isOrderPage!=null?ctrl.isOrderPage:false;
    let reqBody = {
      email: this.email,
      password: this.password,
      agreement: this.agreement,
      phoneNumber: this.phoneNumber,
      customer: {
        firstName: this.firstName,
        lastName: this.lastName
      },
      store: {
        storeURLName: this.storeName
      },
      isExistingRegistration: ctrl.isExistingRegistration,
      percentage: ctrl.percentage ? ctrl.percentage : 0,
      scenario: ctrl.scenario ? ctrl.scenario : 0
    };
    if (ctrl.isExistingRegistration) {
      let state;
      let country;
      if (ctrl.billingCountries.length && ctrl.searchRequest && ctrl.searchRequest.country) {
        let selected = ctrl.billingCountries.find(data => data.label === ctrl.searchRequest.country);
        country = {
          id: selected.value,
          countryCode: selected.label,
          name: selected.name
        };
        if (ctrl.searchRequest.state) {
          let selectedState = selected.states.find(data => data.value === ctrl.searchRequest.state);
          state = {
            id: selectedState.id,
            name: selectedState.label,
            code: selectedState.value
          };
        }
      }
      reqBody = {
        email: this.email,
        password: this.password,
        agreement: this.agreement,
        phoneNumber: this.phoneNumber,
        store: {
          storeURLName: this.storeName
        },
        isExistingRegistration: ctrl.isExistingRegistration,
        percentage: ctrl.percentage ? ctrl.percentage : 0,
        scenario: ctrl.scenario ? ctrl.scenario : 0,
        billingAddressLine1: ctrl.searchRequest ? ctrl.searchRequest.addressLine1 : null,
        billingCity: ctrl.searchRequest ? ctrl.searchRequest.city : null,
        billingState: state ? state : null,
        billingCountry: country ? country : null,
        billingZipCode: ctrl.searchRequest ? ctrl.searchRequest.zipCode : null,
        shippingAddressLine1: ctrl.searchRequest ? ctrl.searchRequest.addressLine1 : null,
        shippingCity: ctrl.searchRequest ? ctrl.searchRequest.city : null,
        shippingState: state ? state : null,
        shippingCountry: country ? country : null,
        shippingZipCode: ctrl.searchRequest ? ctrl.searchRequest.zipCode : null,
        customer: {
          firstName: ctrl.searchRequest ? ctrl.searchRequest.firstName : null,
          lastName: ctrl.searchRequest ? ctrl.searchRequest.lastName : null
        }
      };
    }
    this.authService.registerUser(reqBody,isRegisteringFromGuest)
      .then(
        success => {
          ctrl.$spinner.hide('appSpinner');
          ctrl.isRegistering = false;
          var eventAction = 'RegistrationSuccessful';
          this.requestSent = true;
          this.activationId = success.data.additionalInfo;
          if (ctrl.sendEmailStore) {
            ctrl.sendEmailToStore(0);
          }
          ctrl.reset(ctrl);
          this.$analytics.eventTrack(eventAction,
            {
              category: 'RegistrationSuccessful',
              label: this.storeName + '/' + this.email
            }
          );
          this.goToOTPpage(this.activationId,this.email, this.storeName);
        },
        error => {
          ctrl.$spinner.hide('appSpinner');
          ctrl.isRegistering = false;
          if (error.data.errorCode === 607) {
            this.noEmailError = true;
            return;
          }
          else {
            this.noEmailError = false;
            if (error.data.errorCode === 707 || error.data.errorCode === 615 || error.data.errorCode === 613 || error.data.errorCode === 605) {
              ctrl.signupForm.error = error.data;
            } else {
              ctrl.signupForm.error = { message: 'Registration Failed Please try again!' };
            }
          }
          ctrl.reset(ctrl);
        });
  }

  registrationStore(ctrl) {  
    ctrl.$spinner.show('appSpinner');  
    var potentialRecords = ctrl.customerDetails.filter(item => !item.isFakeAddress).map(ele => ele.customerID);
    this.authService.registerStoreUser({
      email: this.email,
      password: this.password,
      agreement: this.agreement,
      phoneNumber: this.phoneNumber,
      store: {
        storeURLName: this.storeName
      },
      customer: {
        id: this.customerId
      },
      isExistingRegistration: ctrl.isExistingRegistration,
      percentage: ctrl.percentage ? ctrl.percentage : 0,
      potentialRecords: (potentialRecords && potentialRecords.length) ? potentialRecords.toString() : null
    })
      .then(
        success => {
          ctrl.$spinner.hide('appSpinner');
          ctrl.isRegistering = false;
          var eventAction = 'RegistrationSuccessful';
          this.$analytics.eventTrack(eventAction,
            {
              category: 'RegistrationSuccessful',
              label: this.storeName + '/' + this.email
            }
          );
          this.requestSent = true;
          this.activationId = success.data.additionalInfo;
          ctrl.customerDetails = [];
          if (ctrl.sendEmailStore) {
            ctrl.sendEmailToStore(1);
          }
          // ctrl.infoPopUp(this.email);
          ctrl.reset(ctrl);
          this.goToOTPpage(this.activationId, this.email, this.storeName);
        },
        error => {
          ctrl.$spinner.hide('appSpinner');
          ctrl.isRegistering = false;
          ctrl.customerDetails = [];
          if (error.data.errorCode === 607) {
            this.noEmailError = true;
            return;
          }
          else {
            this.noEmailError = false;
            if (error.data.errorCode === 707 || error.data.errorCode === 605) {
              ctrl.signupForm.error = error.data;
            } else {
              ctrl.signupForm.error = { message: 'Registration Failed Please try again!' };
            }
          }
          ctrl.reset(ctrl);
        });
  }

  registrationWelcome(ctrl) {
    this.$uibModal.open({
      size: 'md',
      template: '<div class="modal-header modalheaderbg btn-primary"><h5></h5></div>' +
        '<div class="modal-body" id="modal-body">' +
        '<div class="container-fluid">' +
        '<div class="row">' +
        
        '<div class="col-md-12 p-t-1">' +
        '<h6>We don&#146t find that email address in our records.  If you have shopped with us before, we can get more information to connect to our in-store account.</h6>' +
        '</div>' +

        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn " type="button" ng-click="cancel()" style="float: left;">Cancel</button>' +
        `<button class="btn btn-primary m-l-1" type="button" ng-click="ok(true)" style="float: right;">
        <span>Create New Account </span>
        </button>` +
        `<button class="btn btn-primary m-l-1" type="button" ng-click="ok(false)" style="float: right;">
        <span>Find Me</span>
        </button>` +
        '</div>',
      controller: ['$scope', '$state', '$uibModalInstance','$sce',
        function ($scope, $state, $uibModalInstance,$sce) {
          // eslint-disable-next-line arrow-parens
          // $scope.$sce = $sce;
          $scope.ok = isregister => {
            $uibModalInstance.close();
            if (!isregister) {
              ctrl.registrationInfo(ctrl);
            } else {
              ctrl.sendEmailStore = false;
              ctrl.isExistingRegistration = false;
              ctrl.registration(ctrl);
            }
          };
          $scope.cancel = () => $uibModalInstance.dismiss('cancel');
        }
      ],
      resolve: {

      }
    });
  }

  registrationInfo(ctrl) {
    this.$uibModal.open({
      size: 'md',
      template: '<div class="modal-header modalheaderbg btn-primary"><h5></h5></div>' +
        '<div class="modal-body" id="modal-body">' +
        '<div class="container-fluid">' +
        '<div class="row">' +
        ` <form name="registrationForm"
        ng-submit="submit(registrationForm)"
        autocomplete="off"
        novalidate>
        <div class="col-md-12 error-text" ng-if="registrationForm.error.message">{{registrationForm.error.message}}</div>
        <div class="col-md-6">
            <div class="form-group">
              <label>First Name </label>
              <input name="fName" type="text" ng-model="fName" class="form-control"/>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
              <label>Last Name* </label>
              <input name="lName" type="text" required ng-model="lName" class="form-control"/>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
              <label>Address </label>
              <input name="address" type="text" ng-model="address" class="form-control"/>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
              <label>City </label>
              <input name="city" type="text" ng-model="city" class="form-control"/>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
              <label>Country </label>
              <select name="country"
                ng-model="country"
                class="form-control"
                ng-change='getStates(country)'>
                <option value="">Select</option>
                <option ng-repeat="item in billingCountries" value="{{item.label}}">
                  {{ item.label }}
                </option>
              </select>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
              <label>State/Province </label>
              <select name="state"
                ng-model="state"
                class="form-control">
                <option value="">Select</option>
                <option ng-repeat="item in billingStates" value="{{item.value}}">
                  {{ item.label }}
                </option>
              </select>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
              <label>Zip code </label>
              <input name="zip" type="text" ng-model="zip" class="form-control"/>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
              <label>Alternate Email </label>
              <input name="aEmail" type="text" ng-model="aEmail" class="form-control"/>
            </div>
        </div>
      </form>` +

        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn " type="button" ng-click="cancel()" style="float: left;">Cancel</button>' +
        '<button class="btn btn-primary m-l-1" type="button" ng-click="submit(registrationForm)" style="float: right;">Find</button>' +
        '</div>',
      controller: ['$scope', '$state', '$uibModalInstance',
        function ($scope, $state, $uibModalInstance) {
          $scope.billingCountries = ctrl.billingCountries;
          // eslint-disable-next-line arrow-parens
          $scope.getStates = (country) => {
            var billingStates = '';
            angular.forEach(ctrl.billingCountries, function(value) {              
              if (country === value.label) {
                billingStates = value.states;
              }
            });
        
            $scope.billingStates = billingStates;
          };
          $scope.ok = () => {
            $uibModalInstance.close();
          };
          // eslint-disable-next-line arrow-parens
          $scope.submit = (registrationForm) => {
            if($scope.fName || $scope.lName || $scope.address || $scope.city || $scope.state || $scope.zip || $scope.aEmail) {
              if (($scope.fName || $scope.zip) && $scope.lName) {
                ctrl.findUserInfo(ctrl, $scope, $uibModalInstance);
              } else {
                if (!$scope.lName) {
                  registrationForm.error = {message: 'Please enter Last Name!'};
                } else {
                    registrationForm.error = {message: 'Please enter First Name or Zip Code!'};
                }
              }
            } else {
              registrationForm.error = {message: 'Please enter any of these details!'};
            }
          };
          $scope.cancel = () => $uibModalInstance.dismiss('cancel');
        }
      ],
      resolve: {

      }
    });
  }

  userDetails() {
    var ctrl = this;
    this.$uibModal.open({
      size: 'lgmd',
      template: '<div class="modal-header modalheaderbg btn-primary"><h5></h5></div>' +
        '<div class="modal-body" id="modal-body">' +
        '<div class="container-fluid">' +
        '<h6 ng-if="customerDetails.length">Please select your account. If you do not recognize an account, please call your store for assistance.</h6>' +
        '<div class="col-md-12 error-text" ng-if="error.message">{{error.message}}</div>' +
        '<div class="row">' +
        `
        <div class="table-responsive table-striped" ng-if="customerDetails.length">
          <table class="table list-table">
            <thead class="thead-inverse">
              <tr>
                <th></th>
                <th>Name</th>
                <th>Address</th>
                <th>Phone Number</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
             <tr class="default-cursor" ng-repeat="item in customerDetails">
                <td width="40" >
                <input type="radio" name="selected" ng-model="selected" ng-click="selectedId(item.customerID)" ng-value="$index" class="form-radio-input" />                
                </td>
                <td width="100" ng-bind="item.name"></td>
                <td width="160">{{item.addressLine}} <br/> {{(item.city ? item.city : '') + ' ' + (item.state ? item.state : '') + ' ' + (item.zipCode ? item.zipCode : '') }}</td>
                <td width="60">{{item.phoneNumber ? item.phoneNumber : ''}}</td>
                <td width="100">{{item.email ? item.email : ''}}</td>
              </tr>
              <tr class="default-cursor">
              <td width="40">
              <input type="radio" name="selected" ng-model="selected" ng-click="selectedId(-1)" ng-value="-1" class="form-radio-input" />
              </td>
                <td width="40" colspan="4">None of the above
                </td>
              </tr>
            </tbody>
          </table>
        </div>` +
        `<div class="col-sm-12 gray-text" style="text-align: center" ng-if="!customerDetails.length">
        <h6>We couldn't find a record with the information you provided. For more help, please contact your local store and ask which email is on file, or proceed to create a new account. Thank you, and happy birding!</h6>
        </div>`+

        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="modal-footer">' +        
        '<button class="btn " type="button" ng-click="cancel()" style="float: left;">Cancel</button>' +
        '<button class="btn btn-primary m-l-1" type="button" ng-click="submit()" style="float: right;">Register</button>' +
        // '<button class="btn btn-primary m-l-1" type="button" ng-click="submitRegister()" style="float: right;">Register Without selecting</button>' +
        '<button class="btn " type="button m-l-1" ng-click="back()" style="float: right;">Back</button>' +
        '</div>',
      controller: ['$scope', '$state', '$uibModalInstance',
        function ($scope, $state, $uibModalInstance) {
          $scope.customerDetails = ctrl.customerDetails;
          $scope.selectedCustomer = null;
          $scope.error = { message: '' };
          $scope.back = () => {
            $uibModalInstance.close();
            ctrl.registrationInfo(ctrl);
          };
          // eslint-disable-next-line arrow-parens
          $scope.selectedId = (id) => {
            $scope.selectedCustomer = id;
          };
          $scope.submit = () => {            
            if (!$scope.customerDetails || !$scope.customerDetails.length) {
              ctrl.sendEmailStore = true;
              ctrl.isExistingRegistration = true;
              ctrl.scenario = 1;
              ctrl.registration(ctrl);
              $uibModalInstance.close();
              return;
            }
            if ($scope.selectedCustomer === -1) {
              ctrl.sendEmailStore = true;
              ctrl.isExistingRegistration = true;
              ctrl.scenario = 1;
              ctrl.registration(ctrl);
              $uibModalInstance.close();
            } else if ($scope.selectedCustomer || $scope.selectedCustomer === 0) {
              $uibModalInstance.close();
              let selected = $scope.customerDetails.find(item => item.customerID === $scope.selectedCustomer);
              if (selected && !selected.email) {                
                ctrl.percentage = 0;
                ctrl.sendEmailStore = true;
                ctrl.isExistingRegistration = true;
                ctrl.customerId = $scope.selectedCustomer;
                ctrl.registrationStore(ctrl);
              } else {
                
                // Selecting preferance email is commented may be used in future
                // ctrl.withPreferanceEmail(ctrl, $scope.selectedCustomer, selected);

                // Without Preferance email i.e registering with selected store email
                ctrl.withoutPreferanceEmail(ctrl, $scope.selectedCustomer, selected);
              }
            } else {
              $scope.error.message = 'Please select any!';
            }
          };
          $scope.submitRegister = () => {
            ctrl.sendEmailStore = true;
            ctrl.isExistingRegistration = true;
            ctrl.scenario = 1;
            ctrl.registration(ctrl);
            $uibModalInstance.close();
            return;
          };
          $scope.cancel = () => $uibModalInstance.dismiss('cancel');
        }
      ],
      resolve: {

      }
    });

  }

  withoutPreferanceEmail(ctrl, selectedCustomer, selected) {
    if (selected && selected.isFakeAddress) {
      ctrl.sendEmailStore = true;
      ctrl.isExistingRegistration = true;
      ctrl.scenario = 2;
      ctrl.registration(ctrl);
    } else {
      const alterEmail = ctrl.searchRequest ? ctrl.searchRequest.email : '';
      const originalCustomer = ctrl.originalCustomerDetails.find(ele => ele.customerID === selectedCustomer);
      if (originalCustomer && originalCustomer.email === alterEmail) {
        ctrl.percentage = 100;
        ctrl.sendEmailStore = false;
      } else {
        ctrl.percentage = 0;
        ctrl.sendEmailStore = true;
      }
      ctrl.isExistingRegistration = true;
      ctrl.email = originalCustomer.email;
      ctrl.customerId = selectedCustomer;
      ctrl.registrationStore(ctrl);
    }
  }

  withPreferanceEmail(ctrl, selectedCustomer, selected) {
    this.$uibModal.open({
      size: 'md',
      template: '<div class="modal-header modalheaderbg btn-primary"><h5>Preferred Email</h5></div>' +
      '<div class="modal-body" id="modal-body">' +
      '<div class="col-md-12 error-text" ng-if="error.message">{{error.message}}</div>' +
        '<h6>Please select an email to Activate/ Register your account with?</h6>' +
        `<input type="radio" name="emailselected" ng-model="emailselected" ng-click="selectedemail('store')" value="store" class="form-radio-input m-l-1" /> ` + selected.email + '   ' +
        `<input type="radio" name="emailselected" ng-model="emailselected" ng-click="selectedemail('entered')" value="entered" class="form-radio-input m-l-1" /> ` + ctrl.email +
      '</div>' +
      '<div class="modal-footer">' +
        '<button class="btn " type="button" ng-click="cancel()" style="float: left;">Cancel</button>' +
        '<button class="btn btn-primary m-l-1" type="button" ng-click="ok()" style="float: right;">Register</button>' +
        '<button class="btn " type="button m-l-1" ng-click="back()" style="float: right;">Back</button>' +
      '</div>',
      controller: ['$scope', '$state', '$uibModalInstance',
        function($scope, $state, $uibModalInstance) {
          $scope.selected = selected;
          $scope.entered = ctrl.email;
          $scope.error = { message: null };
          $scope.back = () => {
            $uibModalInstance.close();
            ctrl.userDetails();
          };
          $scope.ok = () => {
            if (!$scope.emailselected) {
                $scope.error.message = 'Please select any!';
                return;
            }
            if (selected && selected.isFakeAddress) {
              ctrl.sendEmailStore = true;
              ctrl.isExistingRegistration = true;
              ctrl.scenario = 2;
              ctrl.registration(ctrl);
            } else {
              const alterEmail = ctrl.searchRequest ? ctrl.searchRequest.email : '';
              const originalCustomer = ctrl.originalCustomerDetails.find(ele => ele.customerID === selectedCustomer);
              if (originalCustomer && originalCustomer.email === alterEmail) {
                ctrl.percentage = 100;
                ctrl.sendEmailStore = false;
              } else {
                ctrl.percentage = 0;
                ctrl.sendEmailStore = true;
              }
              ctrl.isExistingRegistration = true;
              ctrl.customerId = selectedCustomer;
              if ($scope.emailselected === 'store') {
                ctrl.email = originalCustomer.email;
                // ctrl.percentage = 100;
              }
              ctrl.registrationStore(ctrl);
            }
            $uibModalInstance.close();
          };
          // eslint-disable-next-line arrow-parens
          $scope.selectedemail = (email) => {
            $scope.emailselected = email;
          };
          $scope.cancel = () => $uibModalInstance.dismiss('cancel');
        }
      ],
      resolve: {}
    });  
  }

  findUserInfo(ctrl, scope, uibModalInstance) {
    ctrl.$spinner.show('appSpinner');
    ctrl.customerDetails = [];
    ctrl.searchRequest = {
      firstName: scope.fName,
      lastName: scope.lName,
      email: scope.aEmail,
      phoneNumber: this.phoneNumber,
      addressLine1: scope.address,
      city: scope.city,
      // state: scope.state,
      zipCode: scope.zip,
      store: {
        storeURLName: this.storeName
      }
    };
    this.authService.findCustomerInfo(ctrl.searchRequest).then(success => {
      if (success && success.data && success.data.length) {
        ctrl.originalCustomerDetails = this.refineCustomerList(success.data);
        ctrl.customerDetails = ctrl.maskUpCustomerData(JSON.parse(JSON.stringify(ctrl.originalCustomerDetails)));
      } else {
        ctrl.originalCustomerDetails = [];
        ctrl.customerDetails = [];
      }
      ctrl.$spinner.hide('appSpinner');
      ctrl.userDetails();
    }, error => {
      ctrl.$spinner.hide('appSpinner');
    });
    uibModalInstance.close();
    ctrl.searchRequest = {
      firstName: scope.fName,
      lastName: scope.lName,
      email: scope.aEmail,
      phoneNumber: this.phoneNumber,
      addressLine1: scope.address,
      city: scope.city,
      state: scope.state,
      zipCode: scope.zip,
      country: scope.country
    };
  }

  refineCustomerList(list) {
    if (list && list.length) {
      let refined = [];
      list.forEach(item => {
        if (item.isFakeAddress) {
          refined.push(item);
        } else {
          const ele = refined.find(e => ((e.email && item.email)  ? (e.email.toUpperCase() === item.email.toUpperCase()) : (e.email === item.email)));
          if (ele) {
            // eslint-disable-next-line arrow-parens
            const index = refined.findIndex((el) => el === ele);
            if (ele.email === null || ele.email.trim() === '') {
              if ((item.lastName.toUpperCase() === ele.lastName.toUpperCase()) 
              && (item.firstName.toUpperCase() === ele.firstName.toUpperCase()) 
              && (item.zipCode === ele.zipCode) && (item.addressLine && ele.addressLine)) {
                if (item.dscId === 'C' && item.dscExpireDate > ele.dscExpireDate) {
                  refined[index] = item;
                }
              } else {
                refined.push(item);
              }
            } else if (item.dscId === 'C' && item.dscExpireDate > ele.dscExpireDate) {
                refined[index] = item;
            }
          } else {
            refined.push(item);
          }
        }
      });
      return refined;
    }
    return list;
  }

  maskUpCustomerData(customerList) {
    // customerList = this.generateFake(customerList);
    return [...customerList].map(item => {
      item.email = (item.email && item.email.trim() !== '') ? this.protect_email(item.email) : '';
      item.addressLine = item.addressLine ? (item.addressLine.trim() ? this.protect_address(item.addressLine.trim()) : '') : '';
      item.state = item.state ? item.state.trim() : '';
      item.city = item.city ? item.city.trim() : '';
      item.zipCode = item.zipCode ? item.zipCode.trim() : '';
      item.phoneNumber = (item.phoneNumber && item.phoneNumber.trim() !== '') ? "(XXX) XXX-" + item.phoneNumber.substring(item.phoneNumber.length - 4) : '';
      return item;
    });
  }

  sendEmailToStore(isCustomerMapped) {
    this.authService.sendEmailToStore(isCustomerMapped, {
      email: this.email,
      phoneNumber: this.phoneNumber,
      store: {
        storeURLName: this.storeName
      }
    })
      .then(success => {});
  }

  resendEmail() {
    this.success = null;
    this.error = null;
    this.authService.resendEmail({
      id: this.activationId,
      email: this.email
    })
      .then(success => this.success = success.data.message)
      .catch(err => this.error = err.data.message);
  }

  protect_email = function (user_email) {
    var avg, splitted, part1, part2;
    splitted = user_email.split("@");
    part1 = splitted[0];
    avg = part1.length / 2;
    // part1 = part1.substring(0, (part1.length - avg)) + part1.substring(avg, part1.length - 1).replace(/./g, '*') + part1[part1.length - 1];
    // part1 = part1.substring(0, (part1.length - avg)) + '***' + part1[part1.length - 1];
    part1 = part1.substring(0, 2) + '***' + part1[part1.length - 1];
    part2 = splitted[1];
    return part1 + "@" + part2;
};

protect_address = function (address) {
  var splitted = address.split(" ");
  splitted = splitted.map((item, index) => {
    if (index !== 0) {
      // const average = item.length / 2;
      const average = 2;
      // item = item.substring(0, average) + item.substring(average, item.length - 1).replace(/./g, '*') + item[item.length - 1];
      item = item.substring(0, average) + '***' + item[item.length - 1];
    }
    return item;
  });
  return splitted.join(' ');
};

reset(ctrl) {
  ctrl.originalCustomerDetails = [];
  ctrl.customerDetails = [];
  ctrl.sendEmailStore = null;
  ctrl.isExistingRegistration = null;
  ctrl.customerId - null;
  ctrl.percentage = null;
  ctrl.searchRequest = null;
}

goToOTPpage(id, email, storeName) {
  if (this.store && this.store.hasOtp) {
    this.$state.go('otpactivate', {storeName, id, email});
  }
}

togglePassword(passwordId,toggleId) {
  this.authService.togglePassword(passwordId,toggleId);
}

infoPopUp(registeredEmail){
  console.log("Showing pop up for registering Email : "+ registeredEmail);

  var $ctrl = this;
  this.$uibModal.open({
    size: 'md',
    template: '<div class="modal-header modalheaderbg btn-primary"><h5>Registeration Successful</h5></div>' +
      '<div class="modal-body" id="modal-body">' +
      '<h6>One more step! We have sent an email to the email on file ('+registeredEmail+') to verify your identity. Please use this email to finalize your account setup. </h6>' +
      '</div>' +
      '<div class="modal-footer">' +
      '<button class="btn btn-primary m-l-1" type="button" ng-click="ok()" style="float: right;">OK</button>' +
      '</div>',
    controller: ['$scope', '$state', 'orderService', '$uibModalInstance',
      function ($scope, $state, $order, $uibModalInstance) {
        $scope.ok = () => {
          $uibModalInstance.close();
        };
        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
      }
    ],
    resolve: {

    }
  });

}

doGuestOptIn(orderId) {
  var data = {};
  data.orderId = orderId;
  this.$order.doGuestOptIn(data);
}

}



// WEBPACK FOOTER //
// ./src/app/auth/signup/signup.js